var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/@stimulus/polyfills/~/core-js/modules/_has.js
// module id = 94
// module chunks = 0